import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import type { ContactInfo } from '../types';

interface ContactInfoCardProps {
  contacts: ContactInfo[];
}

const ContactInfoCard = ({ contacts }: ContactInfoCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h3 className="text-base font-semibold text-white/90">{t('footer.sections.contactInfo')}</h3>
      <div className="space-y-3">
        {contacts.map((contact, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-lg bg-white/10 border border-white/10 flex items-center justify-center flex-shrink-0">
              <Icon name={contact.icon} size={16} color="var(--color-accent)" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-white/40 mb-0.5">{contact.label}</p>
              {contact.href ? (
                <a
                  href={contact.href}
                  className="text-sm text-white/80 hover:text-accent transition-colors"
                >
                  {contact.value}
                </a>
              ) : (
                  <p className="text-sm text-white/80">{contact.value}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfoCard;